module.exports = __webpack_public_path__ + "img/avatar1.df43d8fb.png";